import { buildApiUrl } from './api-host';

const POLL_INTERVAL_MS = 3000;
const BG_POLL_TIMEOUT_MS = 15000;

function getWrapperByKey(key) {
  if (!key) return { open: '', close: '' };
  switch (String(key)) {
    case 'monetka':
    case 'cash2you':
      return { open: '<div class="tpl-offers tpl-row tpl-align-horisontal-start tpl-js-offers-wrapper">', close: '</div>' };
    case 'denga':
      return { open: '<div class="tpl-offers">', close: '</div>' };
    case 'tzaem':
      return { open: '<div class="offers__items">', close: '</div>' };
    case 'template1':
      return { open: '<div class="offers__list">', close: '</div>' };
    default:
      if (typeof key === 'string' && key.startsWith('div.')) {
        const classes = key.slice(4);
        return { open: `<div class="${classes}">`, close: '</div>' };
      }
      return { open: '', close: '' };
  }
}

function getBankiRuParams() {
  const urlParams = new URLSearchParams(window.location.search);
  const alg = urlParams.get('alg') || '';
  // Dev-only: scenario selector for MSW (not used by backend)
  const bankiruCase = urlParams.get('bankiru_case') || '';

  // Для локального тестирования: берем phone и name из GET-параметров если window переменные не заданы
  if (!window.__bankiruPhone) {
    window.__bankiruPhone = urlParams.get('ph');
  }

  return { alg, bankiruCase };
}

export function initBankiRu({ renderCard, wrapperOpen = '', wrapperClose = '' }) {
  // === B24-91754: режим страницы заявки mnedali.ru/{token} ===
  // Токен — 6 символов base62 (непрогнозируемый, не раскрывает id заявки, как раньше
  // c.mnedali.ru/BlhjE8). Два замка: формат токена в пути И #lead-offers-header в DOM.
  // Header рендерится сервером только на mnedali (guard в MainController::leadOffers),
  // поэтому lead-режим физически невозможен на других витринах.
  // Ветка стоит ПЕРВОЙ — до всех проверок rollout/телефона ниже: банкиру включается
  // безусловно, распределение и наличие __bankiruPhone не проверяются.
  const leadMatch = window.location.pathname.match(/^\/([A-Za-z0-9]{6})$/);
  const leadToken = leadMatch && document.getElementById('lead-offers-header') ? leadMatch[1] : null;

  if (leadToken) {
    initBankiRuForLead({ renderCard, wrapperOpen, wrapperClose, leadToken });
    return;
  }

  const { alg, bankiruCase } = getBankiRuParams();

  // Dev helper: allow enabling rollout from URL (?bankiru=1)
  const __url = new URLSearchParams(window.location.search);
  if (__url.get('bankiru') === '1' || __url.get('bankiru_enable') === '1') {
    window.__bankiRuInRollout = true;
  }

  // Rollout flag from visit/track response (set in api-host.js).
  // If explicitly false — do not render or call API
  if (window.__bankiRuInRollout === false) {
    $('[data-bankiru-section], .offers__bankiru, #bankiru-section').remove();
    return;
  }

  if (!window.__bankiruPhone) {
    $('.tpl-sect__bankiru, #bankiru-section').remove();
    return;
  }

  // Require rollout true; no legacy __bankiRuEnabled gate
  if (window.__bankiRuInRollout !== true) return;

  // Section selection: prefer data attribute to allow per-vitrina wrappers
  const $section = $('[data-bankiru-section], .offers__bankiru, .bankiru-section');
  const $block = $('#bankiru-block');
  const $preloader = $('#bankiru-preloader');
  // Cards root hook: accept either data-bankiru-offers (legacy) or data-banki-ru-offers (new)
  const $cardsContainer = $block.find('[data-bankiru-offers], [data-banki-ru-offers]');
  const $modal = $('#bankiru-modal');
  let __bankiruScrollY = 0;

  if (!$section.length) return;

  // Изначально скрываем секцию; показываем её только в нужных сценариях ниже
  $section.hide();
  $preloader.hide();

  // 1. Получаем офферы (или узнаём, что идёт прескоринг)
  const firstQuery = new URLSearchParams({
    ph: window.__bankiruPhone,
    ...(alg ? { alg } : {}),
    ...(window.__visitId ? { visitId: window.__visitId } : {}),
    ...(bankiruCase ? { bankiru_case: bankiruCase } : {}),
  }).toString();
  fetch((buildApiUrl('/api/bankiru/get') || '/api/bankiru/get') + '?' + firstQuery, { method: 'GET' })
    .then(r => r.json())
    .then(res => {
      const result = String(res?.result || '').toLowerCase();
      const started = !!res?.isPrescoringStarted;
      if (result === 'success' && Array.isArray(res.prescoringList) && res.prescoringList.length) {
        // Успех: показываем офферы сразу в секции
        $preloader.hide();
        $section.show();
        showCards(res.prescoringList, undefined);
        return;
      }
      if (result === 'pending') {
        if (started) {
          // pending + isPrescoringStarted=true: прелоадер скрыт, блок скрыт, фоновый опрос
          $preloader.hide();
          hideBlock();
          backgroundPoll(true);
          return;
        }
        // pending + isPrescoringStarted=false: показать прелоадер и секцию, фоновый опрос
        $section.show();
        $preloader.show();
        backgroundPoll(false);
        return;
      }
      // error/timeout: не показываем прелоадер, скрываем блок
      $preloader.hide();
      hideBlock();
    })
    .catch(() => { $preloader.hide(); hideBlock(); });

  function backgroundPoll(initialStarted) {
    const start = Date.now();
    let lastPrescoringStarted = initialStarted;
    const t = setInterval(() => {
      // Таймаут: применяется только если в крайнем ответе was isPrescoringStarted=false
      if (!lastPrescoringStarted && Date.now() - start >= BG_POLL_TIMEOUT_MS) {
        clearInterval(t);
        $preloader.hide();
        hideBlock();
        return;
      }
      const q = new URLSearchParams({
        ph: window.__bankiruPhone,
        ...(alg ? { alg } : {}),
        ...(window.__visitId ? { visitId: window.__visitId } : {}),
        ...(bankiruCase ? { bankiru_case: bankiruCase } : {}),
      }).toString();
      fetch((buildApiUrl('/api/bankiru/get') || '/api/bankiru/get') + '?' + q, { method: 'GET' })
        .then(r => r.json())
        .then(res => {
          const result = String(res?.result || '').toLowerCase();
          if (result === 'success' && Array.isArray(res.prescoringList) && res.prescoringList.length) {
            clearInterval(t);
            $preloader.hide();
            if (lastPrescoringStarted) {
              showModal(res.prescoringList, undefined);
            } else {
              $section.show();
              showCards(res.prescoringList, undefined);
            }
            return;
          }
          if (result === 'pending') {
            lastPrescoringStarted = !!res?.isPrescoringStarted;
            if (lastPrescoringStarted) {
              // Прескоринг запущен: прячем прелоадер и блок
              $preloader.hide();
              hideBlock();
            }
            // keep polling
            return;
          }
          // error or other – stop polling; прячем прелоадер и секцию
          clearInterval(t);
          $preloader.hide();
          hideBlock();
        })
        .catch(() => { clearInterval(t); $preloader.hide(); hideBlock(); });
    }, POLL_INTERVAL_MS);
  }

  function showCards(list, bankiruLeadId) {
    $preloader.hide();
    // Skip offers that are already expired at render time
    const nowTs = Date.now();
    const filtered = Array.isArray(list)
      ? list.filter(p => {
          const ts = p && p.approvalTermExpire ? new Date(p.approvalTermExpire).getTime() : null;
          return ts == null || ts > nowTs;
        })
      : [];
    if (!filtered.length) {
      // Nothing to show
      $section.hide();
      if ($modal && $modal.length) { $modal.hide(); }
      return;
    }
    // Update title verb to reflect offers are approved/shown
    const $verb = $('[data-bankiru-title-verb]');
    if ($verb && $verb.length) $verb.text('Одобрили');
    // Optional per-family wrapper rendering
    if (wrapperOpen || wrapperClose) {
      const cardsHtml = filtered.map(renderCard).join('');
      $cardsContainer.html((wrapperOpen || '') + cardsHtml + (wrapperClose || ''));
      startCountdownTimers();
      trackEvent('bankiru_offer_impression', { bankiruLeadId, count: filtered.length });
      bindClicks(bankiruLeadId);
      return;
    }
    const wrapperKey =
      $cardsContainer.data('bankiruWrapper') ||
      $cardsContainer.data('wrapper') ||
      $section.data('bankiruWrapper') ||
      $section.data('wrapper') ||
      '';
    const wrap = getWrapperByKey(wrapperKey);
    const cardsHtml = filtered.map(renderCard).join('');
    $cardsContainer.html(wrap.open + cardsHtml + wrap.close);
    startCountdownTimers();
    trackEvent('bankiru_offer_impression', { bankiruLeadId, count: filtered.length });
    bindClicks(bankiruLeadId);
  }

  function showModal(list, bankiruLeadId) {
    const nowTs = Date.now();
    const filtered = Array.isArray(list)
      ? list.filter(p => {
          const ts = p && p.approvalTermExpire ? new Date(p.approvalTermExpire).getTime() : null;
          return ts == null || ts > nowTs;
        })
      : [];
    if (!filtered.length) {
      // Nothing to show — ensure modal stays hidden
      if ($modal && $modal.length) { $modal.hide(); }
      return;
    }
    $('#bankiru-modal-count').text(filtered.length);
    // Update title verb to reflect offers arrival
    const $verb = $('[data-bankiru-title-verb]');
    if ($verb && $verb.length) $verb.text('Одобрили');
    // Рендерим карточки в основной блок c учётом обёртки
    if (wrapperOpen || wrapperClose) {
      const cardsHtml = filtered.map(renderCard).join('');
      $cardsContainer.html((wrapperOpen || '') + cardsHtml + (wrapperClose || ''));
      // Start timers immediately so countdown is visible even before closing modal
      startCountdownTimers();
      $preloader.hide();
      $section.show();
      // Ensure clicks are ready once modal is dismissed or if user closes it
      bindClicks(bankiruLeadId);
      $modal.css('display', 'flex');
      trackEvent('bankiru_modal_shown', { bankiruLeadId });
      $('#bankiru-modal-cta').one('click', () => {
        $modal.hide();
        trackEvent('bankiru_modal_click', { bankiruLeadId });
        startCountdownTimers();
        bindClicks(bankiruLeadId);
        trackEvent('bankiru_offer_impression', { bankiruLeadId, count: filtered.length });
        // Smooth-scroll to BankiRu section after showing cards
        $('html,body').animate({ scrollTop: $section.offset().top }, 400);
      });
      $('.bankiru-modal__close, .bankiru-modal__overlay').one('click', () => {
        $modal.hide();
        bindClicks(bankiruLeadId);
      });
      return;
    }
    const wrapperKey =
      $cardsContainer.data('bankiruWrapper') ||
      $cardsContainer.data('wrapper') ||
      $section.data('bankiruWrapper') ||
      $section.data('wrapper') ||
      '';
    const wrap = getWrapperByKey(wrapperKey);
    const cardsHtml = filtered.map(renderCard).join('');
    $cardsContainer.html(wrap.open + cardsHtml + wrap.close);
    // Start timers immediately so countdown is visible even before closing modal
    startCountdownTimers();
    $preloader.hide();
    $section.show();
    bindClicks(bankiruLeadId);
    $modal.css('display', 'flex');
    trackEvent('bankiru_modal_shown', { bankiruLeadId });
    $('#bankiru-modal-cta').one('click', () => {
      $modal.hide();
      trackEvent('bankiru_modal_click', { bankiruLeadId });
      startCountdownTimers();
      bindClicks(bankiruLeadId);
      trackEvent('bankiru_offer_impression', { bankiruLeadId, count: filtered.length });
      $('html,body').animate({ scrollTop: $section.offset().top }, 400);
    });
    $('.bankiru-modal__close, .bankiru-modal__overlay').one('click', () => {
      $modal.hide();
      bindClicks(bankiruLeadId);
    });
  }

  function revealCards(bankiruLeadId) {
    $('html,body').animate({ scrollTop: $section.offset().top }, 400);
    trackEvent('bankiru_offer_impression', { bankiruLeadId, count: $cardsContainer.children().length });
    bindClicks(bankiruLeadId);
  }

  function hideBlock() { $section.hide(); }

  function bindClicks(bankiruLeadId) {
    // Rebind with namespacing to avoid duplicates
    $cardsContainer.off('click.bankiru')
      // Fallback: explicit button click (runs first and cancels others)
      .on('click.bankiru', '.bankiru-card__btn', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

        const $wrapper = $(this).closest('[data-product-id], [data-product-code]');
        const productId = $wrapper.data('product-id') || $wrapper.data('product-code');
        if (!productId) return;
        post(buildApiUrl('/api/bankiru/click') || '/api/bankiru/click', { bankiruProductId: productId, ...(window.__visitId ? { visitId: window.__visitId } : {}) })
          .then(res => { if (res && res.result === 'success' && res.partnerUrl) window.open(res.partnerUrl, '_blank'); })
          .catch(() => {});
      })
      // Make entire card clickable; ignore clicks that originated on the explicit button (already handled)
      .on('click.bankiru', '[data-product-id], [data-product-code]', function (e) {
        if ($(e.target).closest('.bankiru-card__btn').length) return;
        const $wrapper = $(e.target).closest('[data-product-id], [data-product-code]');
        if ($wrapper.length === 0) return;

        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

        const productId = $wrapper.data('product-id') || $wrapper.data('product-code');
        if (!productId) return;
        post(buildApiUrl('/api/bankiru/click') || '/api/bankiru/click', { bankiruProductId: productId, ...(window.__visitId ? { visitId: window.__visitId } : {}) })
          .then(res => { if (res && res.result === 'success' && res.partnerUrl) window.open(res.partnerUrl, '_blank'); })
          .catch(() => {});
      });
  }

  function startCountdownTimers() {
    $('.bankiru-card__expire').each(function () {
      const expireTimestamp = $(this).data('expire');
      if (!expireTimestamp) return;

      const $countdown = $(this).find('.bankiru-card__countdown');
      const expireDate = new Date(expireTimestamp);

      const updateTimer = () => {
        const now = new Date();
        const diff = expireDate - now;

        // Hide the block entirely when more than 1 hour remains
        if (diff > 3600000) {
          $(this).hide();
          return;
        }

        if (diff <= 0) {
          // Remove whole card when expired
          const $card = $(this).closest('[data-product-id],[data-product-code],.tpl-offer__wrapper');
          $card.remove();
          // If no BankiRu cards remain, hide containers; otherwise update modal count
          const remaining = $cardsContainer.find('[data-product-id],[data-product-code],.tpl-offer__wrapper').length;
          if (remaining === 0) {
            $preloader.hide();
            $section.hide();
            if ($modal && $modal.length) { $modal.hide(); }
          } else if ($modal && $modal.length) {
            $('#bankiru-modal-count').text(remaining);
          }
          return;
        }

        // Ensure visible within the last hour
        $(this).show();
        const hours = Math.floor(diff / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);

        $countdown.text(
          String(hours).padStart(2, '0') + ':' +
          String(minutes).padStart(2, '0') + ':' +
          String(seconds).padStart(2, '0')
        );
      };

      updateTimer();
      setInterval(updateTimer, 1000);
    });
  }

  function fmt(v) { return String(v).replace(/\B(?=(\d{3})+(?!\d))/g, ' '); }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).then(r => r.json());
  }

  function trackEvent(type, extra = {}) {
    post(buildApiUrl('/api/bankiru/event') || '/api/bankiru/event', {
      type,
      visitId: window.__visitId,
      occurredAt: new Date().toISOString(),
      ...extra,
    }).catch(() => {});
  }

  setInterval(() => {
    $('.bankiru-card__expire[data-expire]').each(function () {
      const diff = new Date($(this).data('expire')) - Date.now();
      // If expired: remove card and possibly hide containers
      if (diff <= 0) {
        const $card = $(this).closest('[data-product-id],[data-product-code],.tpl-offer__wrapper');
        $card.remove();
        const remaining = $cardsContainer.find('[data-product-id],[data-product-code],.tpl-offer__wrapper').length;
        if (remaining === 0) {
          $preloader.hide();
          $section.hide();
          if ($modal && $modal.length) { $modal.hide(); }
        } else if ($modal && $modal.length) {
          $('#bankiru-modal-count').text(remaining);
        }
        return;
      }
      // Hide timer when more than 1 hour remains
      if (diff > 3600000) { $(this).hide(); return; }
      // Show when within the last hour
      $(this).show();
      const h = Math.floor(diff / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      $(this).find('.bankiru-card__countdown').text(
        String(h).padStart(2, '0') + ':' +
        String(m).padStart(2, '0') + ':' +
        String(s).padStart(2, '0')
      );
    });
  }, 30000);
}

function initBankiRuForLead({ renderCard, wrapperOpen, wrapperClose, leadToken }) {
  const $section = $('[data-bankiru-section]');
  const $block = $('#bankiru-block');
  const $preloader = $('#bankiru-preloader');
  const $cardsContainer = $block.find('[data-bankiru-offers], [data-banki-ru-offers]');
  const $header = $('#lead-offers-header');

  if (!$section.length || !$cardsContainer.length) return;

  $preloader.show();
  $section.show();

  const showHeaderMessage = (title) => {
    $header.find('h1').text(title);
    $header.find('.tpl-offers-heading__text').hide();
    $header.show();
  };

  fetch(buildApiUrl('/api/bankiru/lead/' + leadToken) || ('/api/bankiru/lead/' + leadToken), { method: 'GET' })
    .then(r => r.json())
    .then(res => {
      $preloader.hide();

      if (!res || res.result !== 'success' || !Array.isArray(res.prescoringList)) {
        $section.hide();
        showHeaderMessage('Заявка не найдена');
        return;
      }

      // Фильтр истёкших офферов
      const nowTs = Date.now();
      const list = res.prescoringList.filter(p => {
        const ts = p && p.approvalTermExpire ? new Date(p.approvalTermExpire).getTime() : null;
        return ts == null || ts > nowTs;
      });

      if (!list.length) {
        $section.hide();
        showHeaderMessage('По вашей заявке продукты не найдены');
        return;
      }

      // Заголовок: номер заявки сервер не знает (в URL — непрогнозируемый токен, не id),
      // поэтому реальный leadId и сумма (smsApprovalAmount — тот же продукт, что в тексте SMS;
      // фолбэк — максимум по списку) подставляются здесь, после ответа API
      const headerAmount = res.smsApprovalAmount
        || Math.max(...list.map(p => p.approvalAmountMax || 0));
      if (res.leadId) {
        $header.find('[data-lead-id]').text(res.leadId);
      }
      $header.find('[data-lead-amount]').text(headerAmount.toLocaleString('ru-RU'));
      $header.show();

      // Карточки
      const cardsHtml = list.map(renderCard).join('');
      $cardsContainer.html((wrapperOpen || '') + cardsHtml + (wrapperClose || ''));

      startLeadCountdownTimers();
      bindLeadClicks(res.visitId);

    })
    .catch(() => {
      $preloader.hide();
      $section.hide();
      showHeaderMessage('Ошибка загрузки');
    });

  function leadPost(path, body) {
    return fetch(buildApiUrl(path) || path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).then(r => r.json());
  }

  function bindLeadClicks(visitId) {
    // window.open ПОСЛЕ асинхронного fetch блокируется браузерами как popup —
    // открываем вкладку синхронно в обработчике клика, URL задаём после ответа.
    const go = (productId) => {
      const win = window.open('', '_blank');

      leadPost('/api/bankiru/click', {
        bankiruProductId: productId,
        visitId: visitId || null,
        leadToken,
      })
        .then(res => {
          if (res && res.result === 'success' && res.partnerUrl) {
            if (win) {
              win.location.href = res.partnerUrl;
            } else {
              window.location.href = res.partnerUrl;
            }
          } else if (win) {
            win.close();
          }
        })
        .catch(() => { if (win) win.close(); });
    };

    $cardsContainer.off('click.bankiru')
      .on('click.bankiru', '.bankiru-card__btn', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
        const $wrapper = $(this).closest('[data-product-id], [data-product-code]');
        const productId = $wrapper.data('product-id') || $wrapper.data('product-code');
        if (productId) go(productId);
      })
      .on('click.bankiru', '[data-product-id], [data-product-code]', function (e) {
        if ($(e.target).closest('.bankiru-card__btn').length) return;
        const $wrapper = $(e.target).closest('[data-product-id], [data-product-code]');
        if (!$wrapper.length) return;
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
        const productId = $wrapper.data('product-id') || $wrapper.data('product-code');
        if (productId) go(productId);
      });
  }

  function startLeadCountdownTimers() {
    $('.bankiru-card__expire').each(function () {
      const expireTimestamp = $(this).data('expire');
      if (!expireTimestamp) return;

      const $countdown = $(this).find('.bankiru-card__countdown');
      const expireDate = new Date(expireTimestamp);

      const updateTimer = () => {
        const diff = expireDate - new Date();

        if (diff > 3600000) { $(this).hide(); return; }

        if (diff <= 0) {
          $(this).closest('.tpl-offer__wrapper, [data-product-id], [data-product-code]').remove();
          const remaining = $cardsContainer.find('[data-product-id], [data-product-code]').length;
          if (remaining === 0) {
            $section.hide();
            showHeaderMessage('По вашей заявке продукты не найдены');
          }
          return;
        }

        $(this).show();
        const hours = Math.floor(diff / 3600000);
        const minutes = Math.floor((diff % 3600000) / 60000);
        const seconds = Math.floor((diff % 60000) / 1000);
        $countdown.text(
          String(hours).padStart(2, '0') + ':' +
          String(minutes).padStart(2, '0') + ':' +
          String(seconds).padStart(2, '0')
        );
      };

      updateTimer();
      setInterval(updateTimer, 1000);
    });
  }
}
